
export const getMatchesByDate = (dateId, matches) => {
  const dateData = matches.find((d) => d.id === dateId);
  return dateData ? dateData.dayMatches : [];
};

// Fonction pour obtenir les matches d'une date spécifique
export const loadingDayMatch = (dateId, matches) => {
  const dateData = matches.find((d) => d.id === dateId);
  return { isLoading: !dateData, dateData };
};

